import lodash from 'lodash';
import moment from 'moment';

export const processes = [
  {
    machine_id: null,
    checkpoints: [
      {
       checkpoint:"स्प्रिंग, स्क्रू, बोल्ट इत्यादि \
       चेक करना टूटा हुआ तोह नहीं ।",
       days: Array(31).fill('')
      },
      {
       checkpoint:"मशीन पर सेफ्टी गार्ड लगा \
       होना चाहिए ।",
       days:Array(31).fill('')
      },
      {
      checkpoint:"फुट पैडल लीवर सही तरह से \
      काम करना और फुट पैडल में \
      डबल स्प्रिंग होना चाहिए ।",
      days:Array(31).fill('')
      },
      {
        checkpoint:"फोटो गार्ड सेंसर काम कर रहा \
        है ।",
        days:Array(31).fill('')
      }
    ]
  },
];